"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StorageKey = void 0;
var StorageKey = {
  REGISTRANT: '@devsisters/web-pre-client:reg'
};
exports.StorageKey = StorageKey;